import { css } from 'styled-components';

import { breakpoint } from 'theme';

export const styleFormField = css`
  ${({ theme }) => css`
    box-shadow: 0 1px 4px 0 ${theme['transparentColors'].flushOrange40};
    outline: solid 1px ${theme.colors['flushOrange']};
  `};

  padding-right: 2.5em;

  ${breakpoint.m`
    padding-right: 2em;
  `}
`;

export const styleLabelInput = css`
  font-size: 1em;
  font-weight: 600;
  line-height: 1.13;
  color: ${({ theme }) => theme.colors['cornflowerBlue']};
  margin-bottom: 0.5em;
  position: relative;
  display: block;

  ${breakpoint.m`
    font-size: 1.125em;
  `}
`;
